import React, { useState, useEffect } from 'react';
import { ListLayout } from '../../containers/Layout';
import { TableRow, TableCell, Button, TableHead, TableBody, Box, IconButton, Tab, Tabs, Tooltip, MenuItem, Menu, ListItemIcon, ListItemText } from '@material-ui/core';
import { AddRounded, CloseRounded, CheckBoxRounded, CloudDownloadRounded, EditRounded, MoreVertRounded, SendRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import StockExtractButton from '../../StockExtractButton';
import DeleteDialogConfirm from '../../../../../commonModules/interface/DeleteDialogConfirm';
import { InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { useSelector } from 'react-redux';


const ListTransferArrivage = (props) => {
    const [view, setView] = useState("arrivage");
    const [single, setSingle] = useState({
        product_id: "",
        shop_id: ""
    });
    const [singleProd, setSingleProd] = useState({});
    const [singleShop, setSingleShop] = useState({});
    const [singleArrivage, setSingleArrivage] = useState({
        purchase: {},
        shop: {},
    });
    const [breadcrumb, setBreadcrumb] = useState("");
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [deletePopUpD, setDeletePopUpD] = useState(false);
    const [toDelete, setToDelete] = useState({
        id: ""
    });
    const [search, setSearch] = useState("");
    const [received, setReceived] = useState("ALL");
    const [filteredList, setFilteredList] = useState([]);
    const [reload, setReload] = useState(false);
    const [selectShop, setSelectShop] = useState("");
    const [selectShopDisplay, setSelectShopDisplay] = useState({
        value: "",
        label: "Tous les Magasins",
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const [openMenu, setOpenMenu] = useState("");
    const fetchTransfers = useFetchTransfers("arrivage");
    const fetchTransfers2 = useFetchTransfers("demande");
    const STATE = useSelector((state) => state.inventory.requestState); 
    const ARRIVAGES = useSelector((state) => state.inventory.arrivages); 
    const DEMANDS = useSelector((state) => state.inventory.demands); 
    const SHOPS = useSelector((state) => state.inventory.shops); 

    useEffect(() => {
        console.log('MOUNTING ListTransferArrivages ');
        if(isEmpty(ARRIVAGES)){
            fetchTransfers();
        }
        if(isEmpty(DEMANDS)){
            fetchTransfers2();
        }
        filterList("", "ALL");
    }, []);

    useEffect(() => {
        console.log('MOUNTING ListTransferArrivages ARRIVAGE OR DEMANDS');
        filterList("", "ALL");
    }, [ARRIVAGES,DEMANDS]);

    const createArrivageList = () => {
        const { currentPage, rowsPerPage } = props;

        return filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((purchase) => {
            let shop = SHOPS[purchase.shop_id];
            return (
                <TableRow key={purchase.id}>
                    <TableCell>{new Date(purchase.creation_date).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{purchase.arrival_date ? new Date(purchase.arrival_date).toLocaleDateString('fr-FR') : "--"} ({new Date(purchase.estimate_arrival_date).toLocaleDateString('fr-FR')})</TableCell>
                    <TableCell>
                        <a href="#" onClick={() => props.handleSingleShop(shop)}>
                            {shop.name}
                        </a>
                    </TableCell>
                    <TableCell>{purchase.received ? "Reçu" : "En attente"}</TableCell>
                    <TableCell>{purchase.comments}</TableCell>
                    <TableCell>
                        <IconButton color="secondary" onClick={() => props.handleSingleArrivage(purchase, shop)}>
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                    <TableCell>
                        <>
                        {!purchase.received && (
                            <IconButton
                                aria-controls={`option-menu${purchase.id}`}
                                aria-haspopup="true"
                                onClick={(event) => setAnchorEl(event.currentTarget, setOpenMenu(purchase.id))}
                            >
                                <MoreVertRounded />
                            </IconButton>
                        )}
                            <Menu
                                MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                }}
                                id={`option-menu${purchase.id}`}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}  
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={openMenu === purchase.id}
                                onClose={() => {
                                    setOpenMenu("");
                                    setAnchorEl(null);
                                }}
                            >
                                <MenuItem onClick={() => props.handleUpdateArrivage(purchase, shop)}>
                                    Modifier
                                </MenuItem>
                                <MenuItem onClick={() => props.handleCompleteArrivage(purchase, shop)}>
                                    Valider la réception
                                </MenuItem>
                                <MenuItem onClick={() => setToDelete(purchase, setDeletePopUp(true))}>
                                    Supprimer
                                </MenuItem>
                            </Menu>
                        </>
                    </TableCell>
                </TableRow>
            );
        });
    };

    const createDemandeList = () => {
        const { currentPage, rowsPerPage } = props;

        return filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((purchase) => {
            let shop = SHOPS[purchase.shop_id];
            return (
                <TableRow key={purchase.id}>
                <TableCell>{new Date(purchase.creation_date).toLocaleString('fr-FR')}</TableCell>
                <TableCell>{new Date(purchase.estimate_arrival_date).toLocaleDateString('fr-FR')}</TableCell>
                <TableCell>
                    <a href="#" onClick={() => props.handleSingleShop(shop)}>
                    {shop.name}
                    </a>
                </TableCell>
                <TableCell>{purchase.comments}</TableCell>
                <TableCell>{purchase.user_name}</TableCell>
                <TableCell>
                    <IconButton color="secondary" onClick={() => props.handleSingleArrivage(purchase, shop)}>
                        <AddRounded />
                    </IconButton>
                </TableCell>
                <TableCell>
                        <>
                        {!purchase.received && (
                            <IconButton
                                aria-controls={`option-menu${purchase.id}`}
                                aria-haspopup="true"
                                onClick={(event) => setAnchorEl(event.currentTarget, setOpenMenu(purchase.id))}
                            >
                                <MoreVertRounded />
                            </IconButton>
                        )}
                            <Menu
                                MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                }}
                                id={`option-menu${purchase.id}`}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}  
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={openMenu === purchase.id}
                                onClose={() => {
                                    setOpenMenu("");
                                    setAnchorEl(null);
                                }}
                            >
                                <MenuItem onClick={() => props.handleUpdateDemand(purchase, shop)}>
                                    Modifier Demande
                                </MenuItem>
                                <MenuItem onClick={() => setToDelete(purchase, setDeletePopUpD(true))}>
                                    Supprimer
                                </MenuItem>
                            </Menu>
                        </>
                    </TableCell>
                </TableRow>
            );
        });
    };

    const createShopList = () => {
        const list = [{ value: "", label: "Tous les Magasins" }];
        if (SHOPS) {
            Object.values(SHOPS).map((shop) => {
                list.push({ value: shop.id, label: shop.name });
            });
        }
        return list;
    };

    const shopFilter = (selected) => {
        const { ARRIVAGES } = props;
        let filteredShop = Object.values(ARRIVAGES).filter((purchase) => purchase.shop_id === selected);

        console.log({ filteredShop });

        return filteredShop;
    };

    const filterList = (selectedShop = selectShop, searchReceived = received, searchView = view) => {
        console.log({ selectedShop, searchView });
        let list = Object.values(ARRIVAGES);
        if (searchView === "demandes") {
            list = Object.values(DEMANDS);
        }
        let filteredList = selectedShop ? shopFilter(selectedShop) : list;
        if (typeof searchReceived == "boolean") {
            filteredList = filteredList.filter((item) => item.received == searchReceived);
        }
        setFilteredList(filteredList);
        setReload(!reload);
        setView(searchView);
    };

    const deleteArrivage = async (comments) => {
        let data = {
            op_id: toDelete.id,
            comments,
        };
        await props.deleteArrivage(data);

        if (STATE.arrivages.error) {
            console.log("[ERROR] delete purchase", STATE.arrivages.error);
            toast.error(STATE.arrivages.error);
        } else {
            toast.success("Arrivage supprimé avec succès");
            setDeletePopUp(false);
            setToDelete({ id: "" });
            setAnchorEl(null);
            setOpenMenu("");
        }
    };

    const deleteDemand = async (comments) => {
        console.log("[DELETE],deleteDemand",comments)
        let data = {
        op_id: toDelete.id,
        comments,
        };
        try{
            const resp = await props.deleteDemand(data);
            console.log("fetched");
            toast.success("Demande supprimée avec succès");
            setDeletePopUpD(false);
            setToDelete({ id: "" });
            setAnchorEl(null);
            setOpenMenu("");
        }catch(err){
            console.log("ERROR", err);
            toast.error("[ERROR],"+err.message)
        }   
            
    };

  let shops = createShopList();

    return (
        <Box>
            {deletePopUp && (
                <DeleteDialogConfirm
                    title={"l'arrivage n°" + toDelete.id}
                    handleSubmit={deleteArrivage}
                    block={true}
                    close={() => setDeletePopUp(false)}
                />
            )}
            {deletePopUpD && (
                <DeleteDialogConfirm
                    title={"la demande n°" + toDelete.id}
                    handleSubmit={deleteDemand}
                    block={true}
                    close={() => setDeletePopUpD(false)}
                />
            )}

            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <InputSelectMagasin
                    options={shops}
                    value={selectShopDisplay}
                    label="Sélectionner un Magasin"
                    onChange={(option) => {
                        setSelectShopDisplay(option);
                        setSelectShop(option.value);
                        filterList(option.value, undefined);
                    }}
                    maxWidth
                />

                <StockExtractButton
                    icon={<CloudDownloadRounded />}
                    color="secondary"
                    title={view !== "arrivage" ? "Extract demandes" : "Extract Arrivages"}
                    extract={view !== "arrivage" ? "demands" : "arrivages"}
                />
            </Box>
            <Tabs
                value={view}
                onChange={(e, view) => filterList(undefined, undefined, view)}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab value="arrivage" label="Arrivages" />
                <Tab value="demandes" label="Demandes" />
            </Tabs>
            <ListLayout>
                <TableHead>
                <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>{view == "arrivage" ? "Date d'arrivée (estimée)" : "Date souhaitée"}</TableCell>
                    <TableCell>Shop</TableCell>
                    {view == "arrivage" && <TableCell>Etat</TableCell>}
                    <TableCell>Comments</TableCell>
                    {view == "demandes" && <TableCell>Demandeur</TableCell>}
                    <TableCell>Détails</TableCell>
                    <TableCell>Options</TableCell>
                </TableRow>
                </TableHead>
                {view == "arrivage" ? (
                    <TableBody>
                        {filteredList.length > 0 && createArrivageList()}
                        {filteredList.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={6}>
                            <div className="text-center">
                                Cliquez sur{" "}
                                <Button
                                    color="primary"
                                    className="text-right"
                                    onClick={() => props.handleOpenForm("new", "Nouvel Arrivage")}
                                >
                                Nouveau
                                </Button>{" "}
                                pour entrer un nouvel Arrivage
                            </div>
                            </TableCell>
                        </TableRow>
                        )}
                    </TableBody>
                ) : (
                    <TableBody>
                        {filteredList.length > 0 && createDemandeList()}
                        {filteredList.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={6}>
                            <div className="text-center">
                                Cliquez sur{" "}
                                <Button
                                    color="primary"
                                    className="text-right"
                                    onClick={() => props.handleOpenForm("newDemand", "Nouvelle demande d'achat")}
                                >
                                Nouveau
                                </Button>{" "}
                                pour entrer une nouvelle Demande d'achat
                            </div>
                            </TableCell>
                        </TableRow>
                        )}
                    </TableBody>
                )}
                {filteredList.length > 0 && (
                    <TableFooterPagination colSpan={6} items={filteredList} onChangePage={props.onChangePage} initialPage={props.currentPage || 0} />
                )}
            </ListLayout>
        </Box>
    );
};

export default ListTransferArrivage;
